import React, { useEffect, useRef, useState } from "react";

const ChoosePepli = () => {
  const videoRef = useRef(null);
  const sectionRef = useRef(null);
  const [hasInteracted, setHasInteracted] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const video = videoRef.current;
    const section = sectionRef.current;
    if (!video || !section) return;

    const handleCanPlay = () => setIsLoading(false);
    const handleWaiting = () => setIsLoading(true);

    video.muted = true;
    video.play().catch((err) => {
      console.warn("Muted autoplay failed:", err.message);
    });

    video.addEventListener("canplay", handleCanPlay);
    video.addEventListener("waiting", handleWaiting);

    const handleUserInteraction = () => {
      setHasInteracted(true);
      if (video) {
        video.muted = false;
        video.play().catch(() => {});
      }
      window.removeEventListener("click", handleUserInteraction);
      window.removeEventListener("touchstart", handleUserInteraction);
    };

    window.addEventListener("click", handleUserInteraction);
    window.addEventListener("touchstart", handleUserInteraction);

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!video) return;
          if (entry.isIntersecting) {
            video.muted = !hasInteracted;
            video.play().catch(() => {});
          } else {
            video.pause();
          }
        });
      },
      { threshold: 0.5 }
    );

    observer.observe(section);

    return () => {
      observer.disconnect();
      window.removeEventListener("click", handleUserInteraction);
      window.removeEventListener("touchstart", handleUserInteraction);
      video.removeEventListener("canplay", handleCanPlay);
      video.removeEventListener("waiting", handleWaiting);
    };
  }, [hasInteracted]);

  return (
    <section
      id="promo-video"
      ref={sectionRef}
      className="py-10 lg:py-20 bg-gray-50"
    >
      <div className="container mx-auto px-4">
        <div className="flex justify-center relative">
          {isLoading && (
            <div className="absolute inset-0 flex items-center justify-center">
              <div className="animate-spin h-8 w-8 border-4 border-blue-500 border-t-transparent rounded-full" />
            </div>
          )}
          <video
            ref={videoRef}
            className="sm:h-[600px] w-full max-w-5xl md:sm:p-4 rounded-lg shadow-lg"
            playsInline
            loop
            preload="metadata"
            controls
            src="https://pepli-web.s3.us-east-1.amazonaws.com/pepliappintro.mp4"
          />
        </div>
      </div>
    </section>
  );
};

export default ChoosePepli;
